import React from "react";
const DashboardBlockA = ({ block }) => {
  return (
    <>
      <div className="whitespace-nowrap text-sm font-semibold text-neutral-600 max-sm:text-[13px] ">
        {block.title}
      </div>
      <div className="sm:text-2xl max-sm:text-xl max-[400px]:text-base font-semibold text-neutral-700">
        {block.value ? block.value : "0"}
      </div>
    </>
  );
};

export default DashboardBlockA;
